//
//
//
//
//
//
//
//
//

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('VStack', component.exports)
}
export default {
	props: {
		gap: {
			type: [String, Array],
			default: '0'
		},
		padX: {
			type: [String, Array],
			default: '0'
		},
		padY: {
			type: [String, Array],
			default: '0'
		}
	}
};
